// import Cookies from 'js-cookie'
const state = {
  params: {}
}

const mutations = {
  setparams (state, data) {
    // 将token保存到Vuex
    state.params = data
  }
}

const actions = {
  Set_params ({ commit }, payload) {
    commit('setparams', payload)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
